import { useTranslator } from '@bluebeam/react-i18n';
import React, { useEffect } from 'react';
import * as toast from 'utils/toast';
import { product } from 'copy/copy';

const ValidateInternetConnection: React.FC = () => {
  const { translate } = useTranslator(['toastText']);
  const toastText = {
    offline: {
      title: translate('toastText:offline.title'),
      message: translate('toastText:offline.message', {
        productName: product.productName,
      }),
    },
  };
  useEffect(() => {
    const handleOfflineToast = () => {
      toast.offline(toastText);
    };

    window.addEventListener('offline', handleOfflineToast);

    return () => {
      window.removeEventListener('offline', handleOfflineToast);
    };
  }, []);

  return null;
};

export default ValidateInternetConnection;
